import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  Link,
  SvgIcon,
  Switch,
  Typography,
} from '@mui/material';
import { Container, Stack } from '@mui/system';
import { format, parseISO } from 'date-fns';
import { ArrowLeftIcon, ArrowRightIcon } from '@mui/x-date-pickers';
import { useLocation, useNavigate } from 'react-router';
import { RouterLink } from 'src/components/router-link';
import { Seo } from 'src/components/seo';
import { paths } from 'src/paths';
import MedicalDetails from './medicalDetails';
import ExpansionDetails from './expansionDetails';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getSingleScreening } from 'src/redux/actions/patientScreening';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Edit02Icon from '@untitled-ui/icons-react/build/esm/Edit02';
import { Edit } from '@mui/icons-material';

const ScreeningDetails = () => {
  const { state } = useLocation();
  const patientId = state?.patientId;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const screeningData = useSelector((state: any) => state?.getSingleScreeningReducer?.response);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  useEffect(() => {
    dispatch(getSingleScreening(state));
  }, [state]);

  const { patients, patientDetails, screening, sreeningDetails } = paths;

  return (
    <>
      {/* <Seo title="Dashboard: Customer Details" /> */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={4}>
            <Stack spacing={4}>
              <div>
                <Link
                  color="text.primary"
                  onClick={() =>
                    navigate(`${patients}/${patientDetails}${screening}`, {
                      state: {
                        patientId,
                      },
                    })
                  }
                  // component={RouterLink}
                  // href={`${patients}/${patientDetails}${screening}`}
                  sx={{
                    alignItems: 'center',
                    display: 'inline-flex',
                    cursor: 'pointer',
                  }}
                  underline="hover"
                >
                  <SvgIcon sx={{ mr: 1 }}>
                    <ArrowLeftIcon />
                  </SvgIcon>
                  <Typography variant="subtitle2">Back to Screening List</Typography>
                </Link>
              </div>
              <Stack
                alignItems="flex-start"
                direction={{
                  xs: 'column',
                  md: 'row',
                }}
                padding={'0px 0px 40px 0px'}
                justifyContent="space-between"
                spacing={4}
              >
                <Stack
                  alignItems="center"
                  direction="row"
                  spacing={2}
                >
                  <Avatar
                    src={patientData?.profileImage}
                    sx={{
                      height: 64,
                      width: 64,
                    }}
                  >
                    {/* {getInitials(patientData?.firstName)} */}
                  </Avatar>
                  <Stack spacing={1}>
                    <Typography variant="h4">
                      {patientData?.firstName ? patientData?.firstName + ' ' : ''}
                      {patientData?.lastName ? patientData?.lastName : ''} - Screening -{' '}
                      {screeningData?.screeningType
                        .replace(/_/g, ' ')
                        .replace(
                          /\w\S*/g,
                          (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                        )}
                    </Typography>
                    <Stack
                      alignItems="center"
                      direction="row"
                      spacing={1}
                    >
                      <Chip
                        label={patientData?.active === true ? 'Active' : 'Inactive'}
                        size="small"
                        color={patientData?.active === true ? 'success' : 'warning'}
                        clickable={true}
                      />
                    </Stack>
                  </Stack>
                </Stack>
                <Stack>
                  <Button
                    color="inherit"
                    // onClick={() => {
                    //     navigate(`${patients}/${editPatient}`, {
                    //         state: patientId,
                    //     });
                    // }}
                    variant="outlined"
                    component={RouterLink}
                    startIcon={
                      <SvgIcon>
                        <Edit />
                      </SvgIcon>
                    }
                    sx={{ color: 'primary.dark' }}
                  >
                    Edit Details
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Container>
        <Container maxWidth="xl">
          <Grid
            container
            display={'flex'}
            flexDirection={'row'}
            gap={'2rem'}
            flexWrap={{ lg: 'nowrap', md: 'wrap' }}
          >
            <Grid
              item
              xs={12}
              md={3}
              lg={3}
            >
              <Card>
                <CardHeader
                  sx={{ pb: 0 }}
                  title="Basic Details"
                />
                <CardContent>
                  <Grid
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'1rem'}
                  >
                    <Grid>
                      <Typography variant="subtitle2">Screening Date</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {screeningData?.screeningDate
                          ? format(parseISO(screeningData?.screeningDate), 'dd MMM, yy')
                          : '-'}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="subtitle2">Discipline Of Complete</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {screeningData?.disciplineOfComplete
                          ? screeningData?.disciplineOfComplete
                              .replace(/_/g, ' ')
                              .replace(
                                /\w\S*/g,
                                (txt: string) =>
                                  txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                              )
                          : '-'}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="subtitle2">Screening Type</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {screeningData?.screeningType
                          ? screeningData?.screeningType
                              .replace(/_/g, ' ')
                              .replace(
                                /\w\S*/g,
                                (txt: string) =>
                                  txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                              )
                          : '-'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              lg={8.7}
              md={8}
              sm={12}
              display={'flex'}
              flexDirection={'column'}
              gap={'20px'}
            >
              <Card>
                <Stack gap="1rem">
                  <Stack sx={{ padding: ' 1.5rem' }}>
                    <Typography variant="h6">Screening Questions</Typography>
                    <Typography variant="body2">
                      Indicate yes/no if there was a change (improvement or decline) observed or
                      reported in the following areas
                    </Typography>
                  </Stack>
                  <ExpansionDetails data={screeningData} />
                </Stack>
              </Card>
              <Card>
                <Stack gap="1rem">
                  <Stack sx={{ padding: ' 1.5rem' }}>
                    <Typography variant="h6">Eval Details</Typography>
                  </Stack>
                  <Grid
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    sx={{ padding: '10px 1.5rem' }}
                  >
                    <Grid
                      item
                      lg={6}
                    >
                      <Typography variant="subtitle1">Is evaluation neccessary?</Typography>
                      <Typography variant="body2">
                        Toggling means that evaluation is required for the patient
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                    >
                      <FormControlLabel
                        disabled
                        control={<Switch color="primary" />}
                        label="Evaluation required"
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    sx={{ padding: '10px 1.5rem' }}
                  >
                    <Grid
                      item
                      lg={6}
                    >
                      <Typography variant="h6">
                        Eval Disciplines as per the screening done
                      </Typography>
                      <Typography variant="body2">
                        The evals can only be added from the relevant role as per the permissions
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      lg={3}
                    >
                      <Typography variant="subtitle2">OT Added</Typography>
                    </Grid>
                    <Grid>
                      <div>
                        <Link
                          color="#6366F1"
                          component={RouterLink}
                          // href={`${patients}/${patientDetails}${screening}`}
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'row-reverse',
                          }}
                          underline="hover"
                        >
                          <SvgIcon sx={{ ml: 1 }}>
                            <ArrowForwardIcon />
                          </SvgIcon>
                          <Typography variant="subtitle2">Open Eval</Typography>
                        </Link>
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                    ></Grid>
                    <Grid
                      item
                      lg={3}
                    >
                      <Typography variant="subtitle2">OT Added</Typography>
                    </Grid>
                    <Grid>
                      <div>
                        <Link
                          color="#6366F1"
                          component={RouterLink}
                          // href={`${patients}/${patientDetails}${screening}`}
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'row-reverse',
                          }}
                          underline="hover"
                        >
                          <SvgIcon sx={{ ml: 1 }}>
                            <ArrowForwardIcon />
                          </SvgIcon>
                          <Typography variant="subtitle2">Open Eval</Typography>
                        </Link>
                      </div>
                    </Grid>
                  </Grid>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default ScreeningDetails;
